import { createTheme } from "@mui/material";
import styled from "styled-components";

export const DateRangePickerStyled = styled.div`
  width: 100%;
  .label {
    color: var(--slate-blue-color);
    font-weight: 500;
    font-size: 14px;
  }
  .MuiIconButton-root {
    margin-right: 0px;
  }
  .MuiStack-root {
    overflow: hidden !important;
    padding-top: 0px !important;
  }

  .MuiTextField-root {
    border-radius: 12px !important;
    width: 100%;
  }

  .MuiInputBase-input {
    font-size: 14px !important;
    font-weight: 500 !important;
  }

  .MuiPickersCalendarHeader-root {
    justify-content: center;

    .MuiTypography-root {
      font-size: 16px !important;
      font-weight: bold !important;
    }
  }

  .MuiPickersMonth-root {
    border-radius: 50% !important;
    padding: 8px 12px !important;
    font-size: 14px !important;
    font-weight: bold !important;
    color: #333 !important;

    &:hover {
      background-color: #f0f0f0 !important;
    }

    &.Mui-selected {
      background-color: #0043ce !important;
      color: #fff !important;
    }
  }
`;

export const theme = createTheme({
  components: {
    MuiStack: {
      styleOverrides: {
        root: {
          overflow: "hidden",
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          "& .MuiOutlinedInput-root": {
            borderRadius: "12px",
            padding: "8px",
          },
          "& .MuiInputBase-input": {
            fontSize: "14px",
            fontWeight: 500,
          },
        },
      },
    },
  },
});
